
































import Vue from 'vue';
import ReportTable, {ColumnConfig} from '@/components/ReportTable.vue';
import ReportControls, {Account, ReportSpecByWeek} from '@/components/ReportControls.vue';
import axios from 'axios';
import XLSX from 'xlsx';

export default Vue.extend({
    name: 'ProductRevenue',
    components: {ReportControls, ReportTable},
    data() {
        return {
            loading: true,
            spec: {} as ReportSpecByWeek,
            headers: [],
            selectedPeriod: [],
            yearToDate: [],
            columnConfig: [
                {},
                {format: 'currency'},
                {format: 'currency'},
                {format: 'currency', aggregate: 'mean'},
                {format: 'currency', decimalPlaces: 0},
            ] as Array<ColumnConfig<string> | ColumnConfig<number>>,
        };
    },
    computed: {
        dataUrl(): string {
            const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
            const {depot, from, to} = this.spec;
            return `${BASE_URL}/reports/customer-revenue-by-space/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
        },
    },
    watch: {
        async spec() {
            this.loading = true;
            const response = await axios.get(this.dataUrl, {
                params: {
                    account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
                },
            });
            this.headers = response.data.headers;
            this.selectedPeriod = response.data.results.selected_period;
            this.yearToDate = response.data.results.year_to_date;
            this.loading = false;
        },
    },
    methods: {
        download() {
            const wb = XLSX.utils.book_new();
            const currentWeekSheet = XLSX.utils.table_to_sheet((this.$refs.selectedPeriod as Vue).$el);
            // const yearToDateSheet = XLSX.utils.table_to_sheet((this.$refs.yearToDate as Vue).$el);
            XLSX.utils.book_append_sheet(wb, currentWeekSheet, 'Selected Period');
            // XLSX.utils.book_append_sheet(wb, yearToDateSheet, 'Year to Date');
            const {depot, from, to} = this.spec;
            XLSX.writeFile(wb, `Customer Product Margins for Depot ${depot} - ${from.year}${to.week} to ${to.year}${to.week}.xlsx`);
        },
    },
});
